import { MqttDingtianEndpointService } from "@/views/loyalty/shared/endpoint_services/mqtt-dingtian-endpoint-service"

export class MqttDingtianService {
    constructor () {
        this.mqttDingtianEndpointService = new MqttDingtianEndpointService()
    }

    // return true - relay is ON, false - relay is OFF
    async getStatus (relaySerialNumber, relayIndex) {
        relayIndex = ++relayIndex // the count is started with 0
        const request = { number: relaySerialNumber, relayIndex: relayIndex, timeout: 0, command: '', status: '', ethernet: false, wifi: false }
        const response = await this.mqttDingtianEndpointService.getStatus(request)
        return response.value.status
    }

    // DELAY, Ethernet
    async sendMessage (relaySerialNumber, relayIndex, timeout) {
        relayIndex = ++relayIndex
        const request = [{ number: relaySerialNumber, relayIndex: relayIndex, timeout: timeout, command: 'DELAY', status: 'ON', ethernet: true, wifi: false }]
        return this.mqttDingtianEndpointService.sendMessage(request)
    }

    // items are [{number, relayIndex, timeout}]
    sendMessageFromCart (items) {
        console.log('sendMessageFromCart items', items)
        // const request = []
        const request = items.map(item => {
            return { number: item.number, relayIndex: ++item.relayIndex, timeout: item.timeout, command: 'DELAY', status: 'ON', ethernet: true, wifi: false }
        })
        console.log('sendMessageFromCart request', request)
        return this.mqttDingtianEndpointService.sendMessageFromCart(request)
    }

    // sendMessageFromCartRepeat (items) {
    //     console.log('sendMessageFromCartRepeat items', items)
    //     items.forEach(async item => {
    //         const request = [{ number: item.number, relayIndex: ++item.relayIndex, timeout: item.timeout, command: 'DELAY', status: 'ON', ethernet: true, wifi: false }]
    //         for (const i of item.repeats.number) {
    //             await this.sleep(item.repeats.beforeTimeout)
    //             console.log('sendMessageFromCartRepeat request', request)
    //             await this.mqttDingtianEndpointService.sendMessage(request)
    //             await this.sleep(item.repeats.afterTimeout)
    //         }
    //     })
    // }
    sendMessageFromCartRepeat (items) {
        console.log('sendMessageFromCartRepeat items', items)
        // const request = []
        const request = items.map(item => {
            return { number: item.number, relayIndex: ++item.relayIndex, timeout: item.timeout, command: 'DELAY', status: 'ON', ethernet: true, wifi: false, operation: { timeoutAfter: item.repeats.afterTimeout, timeoutBefore: item.repeats.afterTimeout } }
        })
        console.log('sendMessageFromCartRepeat request', request)
        return this.mqttDingtianEndpointService.sendMessageRepeat(request)
    }

    sleep (sec) {
        return new Promise(resolve => setTimeout(resolve, sec * 1000))
    }
}
